import { jsx as r } from "react/jsx-runtime";
function e(t) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "26",
      height: "20",
      viewBox: "0 0 26 20",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "rgb(var(--brand-primary))",
      ...t,
      children: /* @__PURE__ */ r("path", { d: "M23.7148 0.859375H2.28516C1.02771 0.859375 0 1.88257 0 3.14453V16.8555C0 18.1179 1.02837 19.1406 2.28516 19.1406H23.7148C24.9723 19.1406 26 18.1174 26 16.8555V3.14453C26 1.88226 24.9718 0.859375 23.7148 0.859375ZM23.3639 2.38281C22.6251 3.12407 13.9468 11.8307 13.5903 12.1884C13.2925 12.4871 12.7077 12.4873 12.4097 12.1884L2.63605 2.38281H23.3639ZM1.52344 16.5754V3.42459L8.07752 10L1.52344 16.5754ZM2.63605 17.6172L9.15302 11.079L11.3308 13.2639C12.2232 14.1592 13.7772 14.1588 14.6693 13.2639L16.847 11.0791L23.3639 17.6172H2.63605ZM24.4766 16.5754L17.9225 10L24.4766 3.42459V16.5754Z" })
    }
  );
}
export {
  e as ClosedLetterIcon
};
